import React, { FC } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  Grid,
  Button,
  ListItem,
  ListItemText,
  DialogContentText,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { CustomerBlackListedData } from '@models';
import moment from 'moment';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  createOrder: () => void;
  isBlackListedData?: CustomerBlackListedData;
};

export const RsbWarningModal: FC<Props> = ({ isOpen, onClose, createOrder, isBlackListedData }) => {
  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogTitle>
        <Typography variant="h6" color="error" display="flex" alignItems="center" justifyContent="center" data-testid="rsb-warning-header">
          <WarningIcon fontSize="inherit" />
          This customer is currently blacklisted
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container direction="column" justifyContent="center" display="flex" alignItems="flex-start">
          {isBlackListedData?.reason && isBlackListedData?.until && (
            <Grid item>
              <ListItem>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" component="span">
                      <strong>Reason:</strong> {isBlackListedData?.reason}
                    </Typography>
                  }
                  data-testid="rsb-warning-reason"
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" component="span">
                      <strong>Until:</strong> {moment(isBlackListedData?.until).format('DD/MM/YYYY, h:mm:ss a')}
                    </Typography>
                  }
                  data-testid="rsb-warning-until"
                />
              </ListItem>
            </Grid>
          )}
          <ListItem>
            <ListItemText
              primary={
                <Typography variant="subtitle2" component="span">
                  <strong>Are you sure you want to proceed?</strong>
                </Typography>
              }
              data-testid="rsb-warning-text"
            />
          </ListItem>
          <DialogActions>
            <Grid ml="8px">
              <Button variant="outlined" onClick={createOrder} data-testid="rsb-create-order-button" style={{ marginRight: 8 }}>
                Create Order
              </Button>
              <Button variant="outlined" onClick={onClose} data-testid="rsb-cancel-button">
                Cancel
              </Button>
            </Grid>
          </DialogActions>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
